import {useParams} from 'react-router-dom';

import {PlanParam, PlanType} from '@/pages/UpgradePlan/components/UpgradePlan/types';

export const useParsePlan = () => {
    const {plan} = useParams<PlanParam>();
    return PlanType[plan as keyof typeof PlanType];
};
